export default __webpack_public_path__ + "static/media/Snd_B_Starts.ac8d3944.mp3";